import { useQuery } from 'react-query';
import axios from 'axios';
import { commonHeaders } from '../../constants/HeadersAPI';
import { LicenseAPI } from '../../constants/API';
import { LicenseTypeEnum } from '../../types/enums';
import { useContext } from 'react';
import { LicenseContext } from '../../context/LisenceContext/LicenseContext';

export type LicenseDataType = {
  customerName: string;
  dateFrom: string; //in format 2025-01-01"
  dateTo: string; //in format 2025-01-01"
  activeDays: number;
  usedDays: number;
  active: boolean;
  type: LicenseTypeEnum;
  licenseNumber: number;
  keyName: string; //Example"12345 ***** ***** 12345"
  mac: string;
};

export const useGetCurrentLicenseData = () => {
  const { updateLicenseData } = useContext(LicenseContext);

  const { data: currentLicenseData, isFetching: isCurrentLicenseDataFetching } = useQuery({
    queryKey: ['getCurrentLicenseData'],
    queryFn: async () => {
      const { data } = await axios.get<LicenseDataType>(LicenseAPI.currentLicense, commonHeaders());

      updateLicenseData(data.keyName, data.activeDays - data.usedDays, !data.active);

      return data;
    }
  });
  return {
    currentLicenseData,
    isCurrentLicenseDataFetching
  };
};
